import { Col, Row, Input, Form, Select, Avatar } from 'antd'
import styles from '../styles.module.scss'
import { useContext } from 'react'
import Context from '../../Context'
import { UserInterface } from 'Interfaces'
import find from 'lodash/find'
import BaseLayout from 'components/BaseLayout'
import { TbUser } from 'react-icons/tb'
import get from 'lodash/get'

const { Option } = Select

const UpdateUserInfo: React.FC<{ form: any }> = ({ form }) => {
  const {
    states: { selectedUser },
    queryHandler: { data: dataQuery }
  } = useContext(Context)
  const data = get(dataQuery, 'data', [])
  const user: UserInterface =
    find(data, ({ identity_uuid }) => selectedUser === identity_uuid) ?? {}

  return (
    <BaseLayout className="updateUserCard">
      <div className={styles.updateUser}>
        <Row>
          <Col>
            <div className="modalChild">
              <h2>Actualizar información de usuario</h2>
              <Avatar
                className="img"
                icon={<TbUser style={{ fontSize: '7rem' }} />}
                size={'large'}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#1E99E1'
                }}
              />
              <Form
                form={form}
                layout="vertical"
                style={{ width: 340 }}
                initialValues={{
                  new_firstname: user.identity_first_name,
                  new_lastname: user.identity_last_name,
                  new_email: user.identity_email,
                  new_phone: user.identity_phone
                }}
              >
                <Form.Item
                  label="Nombre"
                  name="new_firstname"
                  rules={[
                    { required: true, message: 'Nombre es un campo requerido' }
                  ]}
                >
                  <Input placeholder="Juan" />
                </Form.Item>
                <Form.Item
                  label="Apellido"
                  name="new_lastname"
                  rules={[
                    {
                      required: true,
                      message: 'Apellido es un campo requerido'
                    }
                  ]}
                >
                  <Input placeholder="Perez" />
                </Form.Item>
                <Form.Item
                  label="Email"
                  name="new_email"
                  rules={[
                    {
                      required: true,
                      message: 'El Email es un campo requerido',
                      type: 'email'
                    }
                  ]}
                >
                  <Input type="email" placeholder="john.doe@ex.com" />
                </Form.Item>
                <Form.Item
                  label="Teléfono"
                  name="new_phone"
                  rules={[
                    {
                      required: true,
                      message: 'El numero telefonico es un campo requerido'
                    }
                  ]}
                >
                  <Input type="text" placeholder="(333)56738734" />
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </BaseLayout>
  )
}

export default UpdateUserInfo
